export default __webpack_public_path__ + "static/media/cara.b422f6a3.svg";